/**
 * @class 	excelExport
 * @brief 	The Excel Export class helps export data to CSV format.
 * @details
 * @version 	0.1
 * @date 	07/20/2014
 */
var excelExport = (function() {

	var _arrHeaders1 = [];
	var _arrHeaders2 = [];
	var _arrHeaders3 = [];
	var _arrMonthNames = [
				"January", "February", "March",
				"April", "May", "June", "July",
				"August", "September", "October",
				"November", "December"
		];
	var _date = new Date();


	/**
	 * @fn filter_text
	 * @brief 	Return text content from a string
	 * @param 	str: 	a string potentially containing HTML tags
	 * @return 	String
	 */
	function filter_text(str){
		if(str === undefined || str === null || str.length === 0)
			return '';
		if(typeof str.replace === "function")
			str = str.replace("&#8211", "-")
  	var cleantext = $('<span>'+str+'</span>').text().trim();
  	if(cleantext === 'null')
	  	return '';
  	return cleantext
	}



	/**
	 * @fn _extractColumnHeaderInfo
	 * @brief 	Extract the column headers and their info to use for creating the Excel format.
	 * @param 	arrColHeadersLevel1: 	An array of Column headers for the first level.
	 * @param 	arrColHeadersLevel2:  	An array of Column headers for the second level.
	 * @param 	arrColHeadersLevel3: 	An array of Column headers for the third level.
	 * @return 	void
	 */
	var _extractColumnHeaderInfo = function(arrColHeadersLevel1, arrColHeadersLevel2, arrColHeadersLevel3) {

		//Go through the first column headers to extract the data.
		_arrHeaders1 = [];
		for(var nIndex = 0; nIndex < arrColHeadersLevel1.length; nIndex++) {
			//Create New Object.
			var objHeader = {};

			//Obtain the Header Name
			objHeader["name"] = filter_text(arrColHeadersLevel1[nIndex].titleText);

			//Obtain the number of columns.
			objHeader["numColumns"] = arrColHeadersLevel1[nIndex].numberOfColumns;

			//Push into array.
			_arrHeaders1.push(objHeader);
		}

		//Go through the second column headers to extract the data.
		_arrHeaders2 = [];
		for(var nIndex = 0; nIndex < arrColHeadersLevel2.length; nIndex++) {
			//Create New Object.
			var objHeader = {};

			//Obtain the Header Name
			objHeader["name"] = arrColHeadersLevel2[nIndex].titleText;

			//Obtain the number of columns.
			objHeader["numColumns"] = arrColHeadersLevel2[nIndex].numberOfColumns;

			//Push into array.
			_arrHeaders2.push(objHeader);
		}

		//Go through the third column headers to extract the data.
		_arrHeaders3 = [];
		for(var nIndex = 0; nIndex < arrColHeadersLevel3.length; nIndex++) {
			//Create New Object.
			var objHeader = {};

			//Obtain the Header Name
			objHeader["name"] = arrColHeadersLevel3[nIndex].titleText;

			//Obtain the number of columns.
			objHeader["numColumns"] = arrColHeadersLevel3[nIndex].numberOfColumns;

			//Push into array.
			_arrHeaders3.push(objHeader);
		}
	}

	/**
	 * @fn _createSheetFromArrayofArrays
	 * @brief 	Extract the column headers and their info to use for creating the Excel format.
	 * @param 	data: 	An array of arrays representing the data in a worksheet.
	 * @return 	A Worksheet object to be used with a WorkBook.
	 */
	 var _createSheetFromArrayofArrays = function(data) {

	 	//Declare Important Variables.
		var ws = {};
		var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
		var wscols = [];

		//Go through the data and create cell
		for(var R = 0; R != data.length; ++R) {
			for(var C = 0; C != data[R].length; ++C) {
				//Setup the range of the worksheet to assign later.
				if(range.s.r > R) range.s.r = R;
				if(range.s.c > C) range.s.c = C;
				if(range.e.r < R) range.e.r = R;
				if(range.e.c < C) range.e.c = C;
				wscols.push({wch:15})

				//Setup cell object and value.
				var tempVal;
				if((typeof data[R][C] === 'number') ||
					((typeof data[R][C] === 'string') && (data[R][C].length > 0) && (!isNaN(data[R][C]))))
				{
// 					console.log('data[R][C]', data[R][C]);
					tempVal = parseFloat(data[R][C]);
				}
				else {
					// Make sure value is not null.
					if(data[R][C] !== null) {
						tempVal = data[R][C];
					}
					else {
						tempVal = data[R][C];
					}
				}
				var cell = {v: tempVal };
				if(cell.v === null) {
					continue;
				}

				var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

				//Set the value type.
				if(typeof cell.v === 'number') {
					//Set Cell type to number.
					cell.t = 'n';

					//Make sure and format to the correct decimal places.
					switch(_decimalPlaces(data[R][C])) {
						case 0:
							cell.z = '0';
							break;
						case 1:
							cell.z = '0.0'
							break;
						case 2:
							cell.z = '0.00'
							break;
						case 3:
							cell.z = '0.000'
							break;
						default:
							cell.z = '0.0'
							break;
					}
					XLSX.utils.format_cell(cell);
				}
				else if(typeof cell.v === 'boolean') cell.t = 'b';
				else if(cell.v instanceof Date) {
					cell.t = 'n'; cell.z = XLSX.SSF._table[14];
					cell.v = datenum(cell.v);
				}
				else {
					cell.t = 's';
					cell.v = filter_text(cell.v);					
				}

				//Assign cell to worksheet.
				ws[cell_ref] = cell;
			}
		}

		//Set Worksheet Range.
		if(range.s.c < 10000000) {
			ws['!ref'] = XLSX.utils.encode_range(range);
			ws['!cols'] = wscols;
		}

		//Return Worksheet.
		return ws;
	}

	var _s2ab = function(s) {
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}

	var _decimalPlaces = function(num) {
		var regex = (Config.getLanguage() == Config.LANGUAGE.FRENCH) ? /(?:\,(\d+))?(?:[eE]([+-]?\d+))?$/ : /(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/;
	  var match = (''+num).match(regex);
	  if (!match) { return 0; }
	  return Math.max(
	       0,
	       // Number of digits right of decimal point.
	       (match[1] ? match[1].length : 0)
	       // Adjust for scientific notation.
	       - (match[2] ? +match[2] : 0));
	}

	var _saveExcelFile = function(strFileName, strSheetName, arrSheetData) {
		//Declare Important Variables.
			//Create New Work book
		var wb = {}
        var ws = {};
		wb.SheetNames = [];
		wb.Sheets = {};
		wb.Props = {};
		wb.SSF = {};


		//Create new Work Sheet with data.
		ws = _createSheetFromArrayofArrays(arrSheetData);
		//var csvData = XLSX.utils.sheet_to_csv(ws);

		//Add Work Sheet to Work Book.
		wb.SheetNames = [strSheetName];
		wb.Sheets[strSheetName] = ws;


		var wopts = { bookType:'xlsx', bookSST:true, type:'binary', encoding: 'utf8' };
		var wbout = XLSX.write(wb, wopts);
		//Save Excel file to local computer.
		
		saveAs(new Blob([_s2ab(wbout)],{type:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}), strFileName + ".xlsx")

	}

	return {
		/**
		 * @fn exportToExcelAsTable
		 * @brief 	Combines the data to create and save an excel file in a tabular format.
		 * @param 	arrColHeadersLevel1: 	An array of Column headers for the first level.
		 * @param 	arrColHeadersLevel2:  	An array of Column headers for the second level.
		 * @param 	arrColHeadersLevel3: 	An array of Column headers for the third level.
		 * @param 	arrColDisplayNames: 	An array of column names that are used for display.
		 * @param 	arrColModelName: 		An array of column names that are used for obtaining data.
		 * @param 	arrGridData: 			An array of data.
		 * @return 	void
		 */
		exportToExcelAsTable: function(arrColHeadersLevel1, arrColHeadersLevel2, arrColHeadersLevel3, arrColDisplayNames, arrColModelNames, arrGridData, startGroupColName) {
			//Declare Important Variables.
			var curDate = new Date();
			var strFileName = "";
			var nStartGroupColIndex = arrColModelNames.indexOf(startGroupColName);

			//Extract Column Headers.
			_extractColumnHeaderInfo(arrColHeadersLevel1, arrColHeadersLevel2, arrColHeadersLevel3);

			//Create Data for sheet.
			var arrData = [];				//This is the array you will add to add data to the worksheet.
			var arrNewRow = [];

			///////////////////////////////////////////////////////
			//Add first level Column Headers
			///////////////////////////////////////////////////////
			//Add space for where the group column starts.
			for(var nStartColIndex = 0; nStartColIndex < nStartGroupColIndex; nStartColIndex++) {
				arrNewRow.push("");
			}

			//Add the group column names with spaces
			for(var nIndex = 0; nIndex < _arrHeaders1.length; nIndex++)	{
				var strRegExp = /\"loadComplete\":.*?,|<i>|<\/i>/g;
        _arrHeaders1[nIndex].name = _arrHeaders1[nIndex].name.replace(strRegExp, "");
				//Set Name.
				arrNewRow.push(_arrHeaders1[nIndex].name);

				//Add empty space for the number of columns the header expands over.
				for(var nEndColIndex = 0; nEndColIndex < _arrHeaders1[nIndex].numColumns - 1; nEndColIndex++) {
					arrNewRow.push("")
				}
			}
			arrData.push(arrNewRow.slice(0));

			///////////////////////////////////////////////////////
			//Add second level Column Headers
			///////////////////////////////////////////////////////
			arrNewRow = [];
			//Add space for where the group column starts.
			for(var nStartColIndex = 0; nStartColIndex < nStartGroupColIndex; nStartColIndex++) {
				arrNewRow.push("")
			}

			//Add the group column names with spaces
			for(var nIndex = 0; nIndex < _arrHeaders2.length; nIndex++)	{
				//Set Name.
				arrNewRow.push(_arrHeaders2[nIndex].name);

				//Add empty space for the number of columns the header expands over.
				for(var nEndColIndex = 0; nEndColIndex < _arrHeaders2[nIndex].numColumns - 1; nEndColIndex++) {
					arrNewRow.push("")
				}
			}
			arrData.push(arrNewRow.slice(0));

			///////////////////////////////////////////////////////
			//Add third level Column Headers
			///////////////////////////////////////////////////////
			arrNewRow = [];
			//Add space for where the group column starts.
			for(var nStartColIndex = 0; nStartColIndex < nStartGroupColIndex; nStartColIndex++) {
				arrNewRow.push("")
			}

			//Add the group column names with spaces
			for(var nIndex = 0; nIndex < _arrHeaders3.length; nIndex++)	{
				//Set Name.
				arrNewRow.push(_arrHeaders3[nIndex].name);

				//Add empty space for the number of columns the header expands over.
				for(var nEndColIndex = 0; nEndColIndex < _arrHeaders3[nIndex].numColumns - 1; nEndColIndex++) {
					arrNewRow.push("")
				}
			}
			arrData.push(arrNewRow.slice());

			///////////////////////////////////////////////////////
			//Add Actual Columns.
			///////////////////////////////////////////////////////
			arrData.push(arrColDisplayNames.slice(0));

			///////////////////////////////////////////////////////
			//Add Data.
			///////////////////////////////////////////////////////
			for(var nCurDataIndex = 0; nCurDataIndex < arrGridData.length; nCurDataIndex++) {
				arrNewRow = [];
				for(var nCurCol = 0; nCurCol < arrColModelNames.length; nCurCol++) {
					arrNewRow.push(arrGridData[nCurDataIndex][arrColModelNames[nCurCol]]);
				}
				arrData.push(arrNewRow.slice(0));
			}

			///////////////////////////////////////////////////////
			//Add Indicator Information.
			///////////////////////////////////////////////////////
			//Add Empty Row.
			arrData.push([])

			//Add Indicator Information.
			for(var nCurIndicatorIndex = 0; nCurIndicatorIndex < arrSelectedIndicatorCodes.length; nCurIndicatorIndex++) {
				arrNewRow = [];

				//Find Indicator Definition.
				var objIndicatorMetaInfo = nameValueLib.getValueEX(arrIndicatorMetaData, [arrSelectedIndicatorCodes[nCurIndicatorIndex]]);

				//Add Indicator Name to Row.
				arrNewRow.push(arrSelectedIndicatorNames[nCurIndicatorIndex]);

				//Add Indicator Definition to Row.
				arrNewRow.push(objIndicatorMetaInfo.Definition);

				//Add new row to worksheet data.
				arrData.push(arrNewRow.slice(0));
			}
			var citation = "ICF, 2015. The DHS Program STATcompiler. Funded by USAID. http://www.statcompiler.com. " + _arrMonthNames[_date.getMonth()] + " " + _date.getDate() + " " + _date.getFullYear();
			arrData.push([citation]);

			//Setup File Name.
			var curDate = new Date();
			var strTodaysDate = curDate.getFullYear().toString() + (curDate.getMonth() + 1).toString() + curDate.getDate().toString();
			strTodaysDate += "_" + curDate.getHours().toString() + curDate.getMinutes().toString() +  curDate.getSeconds().toString();

			//var strTodaysDate = curDate.toLocalDateString() + " " + curDate.toLocaleTimeString();
			// Data is still good here and not corrupted yet

			// Map the final data to remove html tags
			arrData = arrData.map(function(varr) {
	  			for(var i in varr) {
		    			varr[i] = filter_text(varr[i]);
					}
  				return varr;
			});

			//Save to Excel.
			_saveExcelFile("STATcompilerExport" + strTodaysDate, "Indicator Data", arrData);
		},
		/**
		 * @fn exportToExcelAsDatabase
		 * @brief 	Combines the data to create and save an excel file in a database format.
		 * @param 	arrCountriesSurveys: 	An array of Countries/Surveys.
		 * @param 	arrIndicators:  		An array of Indicators.
		 * @param 	arrByVariables: 		An array of By Variables.
		 * @param 	arrCharLabels: 			An array of Char Cats / Char Labels
		 * @param 	arrValues: 				An array of Values.
		 * @param 	arrUnselectedCountries: An array of unselected countries.
		 * @return 	void
		 */
		exportToExcelAsDatabase: function(arrCountriesSurveys, arrIndicators, arrByVariables, arrCharLabels, arrValues, arrUnselectedCountries, arrSortedConfidenceIntervals, arrSortedDenominators) {
			//Declare Important Variables.
			var curDate = new Date();
			var arrEnabledCharCats = [];
			var strFileName = "";
			var arrData = [];				//This is the array you will add to add data to the worksheet.

			//Create an array of all enabled Characteristic Categories.
			for(var nCharCatIndex = 0; nCharCatIndex < arrCharLabels.length; nCharCatIndex++) {
				var objCharCat = arrCharLabels[nCharCatIndex];
				for(var nCharLabelIndex = 0; nCharLabelIndex < objCharCat.value.length; nCharLabelIndex++) {
					var objCharLabel = objCharCat.value[nCharLabelIndex];
					if(objCharLabel.value) {
						arrEnabledCharCats.push(objCharCat.name);
						break;
					}
				}
			}
			//Create the header row.
			arrData.push(Config.getUniversalString("excelExportHeader"));
			var hasCI = arrSortedConfidenceIntervals.length > 0;
			if(hasCI){
				arrData[0].push("CI High");
				arrData[0].push("CI Low")
			}

			//Go through each country.
			for(var nCurCountryIndex = 0; nCurCountryIndex < arrCountriesSurveys.length; nCurCountryIndex++) {
				//Get current country.
				var objCountry = arrCountriesSurveys[nCurCountryIndex];
				var ciCountry = hasCI ? arrSortedConfidenceIntervals[nCurCountryIndex] : undefined;


				//If a country is unselected, continue to the next.
				if(arrUnselectedCountries.indexOf(objCountry.name) != -1) {
					continue;
				}

				//Go through each survey of the country.
				for(var nCurSurveyIndex = 0; nCurSurveyIndex < objCountry.value.length; nCurSurveyIndex++) {
					//Get Current Survey.
					var objSurvey = objCountry.value[nCurSurveyIndex];
					var ciSurvey = ciCountry ? ciCountry.value[nCurSurveyIndex] : undefined;

					//If the survey is not enabled, skip it.
					if(objSurvey.value == false) {
						continue;
					}

					//Go through each Indicator.
					for(var nCurIndicatorIndex = 0; nCurIndicatorIndex < arrIndicators.length; nCurIndicatorIndex++) {
						//Get Current Indicator.
						var objIndicator = arrIndicators[nCurIndicatorIndex];

						var ciIndicator = ciSurvey ? ciSurvey.value[nCurIndicatorIndex] : undefined;

						//Setup By Variable Labels for the indicator.
						var arrByVarLabels = [];
						var arrTemp = nameValueLib.getValue(arrByVariables, [objIndicator.alias]) || []; // nameValueLib.getValue return null if not found, so default to empty array
						if(arrTemp.length !== 0) {
							for(var nIndex = 0; nIndex < arrTemp.length; nIndex++) {
								if(arrByVarLabels.indexOf(arrTemp[nIndex]) == -1) {
									arrByVarLabels.push(arrTemp[nIndex]);
								}
							}
						}
						else {//If no By Variables, setup one empty By Variable.
							arrByVarLabels.push("");
						}

						//Loop through each By Variable Label.
						for(var nCurByVariableLabelIndex = 0; nCurByVariableLabelIndex < arrByVarLabels.length; nCurByVariableLabelIndex++) {
							//Get Current By Var Label.
							var strByVariableLabel = arrByVarLabels[nCurByVariableLabelIndex];
							var ciLabel = ciIndicator ? ciIndicator.value[nCurByVariableLabelIndex] : undefined;

							//Loop through all Char Cats for that survey.
							for(var nCharCatIndex = 0; nCharCatIndex < arrCharLabels.length; nCharCatIndex++) {
								//Get Current Char Cat.
								var objCharCat = arrCharLabels[nCharCatIndex];
								var ciCharCat = ciLabel ? ciLabel.value[nCharCatIndex] : undefined;

								//If Characteristic Category is not enabled, ignore it.
								if(arrEnabledCharCats.indexOf(objCharCat.name) == -1) {
									continue;
								}

								//Loop through all characteristic labels for the particular Char Cat.
								for(var nCharLabelIndex = 0; nCharLabelIndex < objCharCat.value.length; nCharLabelIndex++) {
									//Get Current Char Label.
									var objCharLabel = objCharCat.value[nCharLabelIndex];
									var ciCharLabel = ciCharCat ? ciCharCat.value[nCharLabelIndex] : undefined;

									//If the char label is not enabled, continue to next.
									if(!objCharLabel.value) {
										continue;
									}

									////////////////////////////////
									//Create new data row.
									////////////////////////////////
									var arrNewRow = [];

									//Add Country Code.
									arrNewRow.push(objCountry.alias);
									//Add Country Name.
									arrNewRow.push(objCountry.name);
									//Add Survey Year.
									arrNewRow.push(objSurvey.alias);
									//Add Survey Name.
									arrNewRow.push(objSurvey.name);
									//Add Indicator
									arrNewRow.push(objIndicator.name);
									//Add By Variable Label.
									arrNewRow.push(strByVariableLabel);
									//Add Weighted Denominator
									//Add Char Cat.
									arrNewRow.push(objCharCat.name);
									//Add Char Label
									arrNewRow.push(objCharLabel.name);


									//Add Value
									var strValue = nameValueLib.getValueMixed(arrValues, 
										[objCountry.name, objSurvey.name, objIndicator.alias, objCharCat.name, objCharLabel.name, strByVariableLabel],
										[g_nameProp, g_nameProp, g_aliasProp, g_nameProp, g_nameProp, g_nameProp, ]);
									arrNewRow.push(strValue);

									if(ciCharLabel){
											arrNewRow.push(ciCharLabel.value.High);
											arrNewRow.push(ciCharLabel.value.Low);
									}

									//Add new row to data.
									arrData.push(arrNewRow);
								}//END for(var nCharLabelIndex = 0...
							}//END for(var nCharCatIndex = 0...
						}//END for(var nCurByVariableLabelIndex = 0...
					}//END for(var nCurIndicatorIndex = 0...
 				}//END for(var nCurSurveyIndex = 0...
			}//END for(var nCurCountryIndex = 0...

			///////////////////////////////////////////////////////
			//Add Indicator Information.
			///////////////////////////////////////////////////////
			//Add Empty Row.
			arrData.push([])

			//Add Indicator Information.
			for(var nCurIndicatorIndex = 0; nCurIndicatorIndex < arrSelectedIndicatorCodes.length; nCurIndicatorIndex++) {
				arrNewRow = [];

				//Find Indicator Definition.
				var objIndicatorMetaInfo = nameValueLib.getValueEX(arrIndicatorMetaData, [arrSelectedIndicatorCodes[nCurIndicatorIndex]]);

				//Add Indicator Name to Row.
				arrNewRow.push(arrSelectedIndicatorNames[nCurIndicatorIndex]);

				//Add Indicator Definition to Row.
				arrNewRow.push(objIndicatorMetaInfo.Definition);

				//Add new row to worksheet data.
				arrData.push(arrNewRow.slice(0));
			}

      var citation = "ICF, 2015. The DHS Program STATcompiler. Funded by USAID. http://www.statcompiler.com. " + _arrMonthNames[_date.getMonth()] + " " + _date.getDate() + " " + _date.getFullYear();
      arrData.push([citation]);

			//////////////////////////////////////
			// SAVE TO EXCEL.
			//////////////////////////////////////
			var curDate = new Date();
			var strTodaysDate = curDate.getFullYear().toString() + (curDate.getMonth() + 1).toString() + curDate.getDate().toString();
			strTodaysDate += "_" + curDate.getHours().toString() + curDate.getMinutes().toString() +  curDate.getSeconds().toString();
			//var strTodaysDate = curDate.toLocalDateString() + " " + curDate.toLocaleTimeString();

			// Map the final data to remove html tags
			arrData = arrData.map(function(varr){
  				for(var i in varr) {
    					varr[i] = filter_text(varr[i]);
				}
  				return varr;
			});

			//Save to Excel
			_saveExcelFile("STATcompilerExport" + strTodaysDate, "Indicator Data", arrData);

		},
		test: function() {
			console.log("success");
		}
	}
}());
